<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid">

                <div class="row">
                    <div class="col-12 mb-4">
                        <!--  <v-overlay :value="overlay">
                              <v-progress-circular indeterminate size="64"></v-progress-circular>
                          </v-overlay>-->

                        <v-card>
                            <v-card-title>
                                Tous les produits
                                <v-spacer></v-spacer>
                                <v-text-field
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        label="Rechercher ..."
                                        single-line
                                        hide-details
                                        @change="searchCustom"
                                ></v-text-field>

                                <v-menu offset-y>

                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                    color="primary"
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    style="background-color: #2A3042;color: #fff; margin-top: 2%; margin-left: 5%; font-size: 12pt"
                                                    class="mb-2 btn"
                                            >
                                                Ajouter
                                                <v-progress-circular v-if="overlay" indeterminate size="25"
                                                                     style="margin-left: 5px"></v-progress-circular>
                                            </v-btn>

                                        </template>
                                     <!--   <span v-if="overlay">Chargement des produits de notre catalogue en cours ...</span>
                                        <span v-else>Chargement des produits de notre catalogue terminé.</span>
-->
                                    <v-list v-if="!overlay">
                                        <v-list-item
                                                v-for="(item, index) in items"
                                                :key="index"
                                                @click="add_produit(index)"
                                        >
                                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-card-title>
                            <v-data-table
                                    :headers="headers"
                                    :items="pharmaproduits"
                                    :search="search"
                                    sort-by="name"
                                    class="elevation-1"
                                    :loading="pharmaproduitloading" loading-text="Chargement en cours...">


                                <template v-slot:item.produit.photo="{item}">
                                    <a v-if="item.produit.photo" :href="item.produit.photo" target="_blank">
                                        <img :src="item.produit.photo"
                                             style="width: 50px; height: 50px;cursor: pointer; margin: 2% "
                                             data-toggle="modal" data-target="#infos"/>
                                    </a>
                                </template>


                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-spacer></v-spacer>
                                        <v-dialog v-model="dialog" max-width="800px">

                                            <v-card style="">
                                                <v-card-title>
                                                    <span class="headline">Ajout depuis notre catalogue</span>
                                                </v-card-title>

                                                <v-card-text>
                                                    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                        <v-alert v-if="errors" dense outlined
                                                                 :type="(errors.update_error)?'error':'success'">
                                                            {{errors.operation}}
                                                        </v-alert>

                                                        <v-text-field v-if="submitting" color="primary" loading
                                                                      disabled></v-text-field>
                                                        <v-col cols="12" sm="12" md="12">
                                                            <v-container>
                                                                <v-autocomplete

                                                                        :rules="produitRules"
                                                                        v-model="editedItem.produit"
                                                                        :loading="loading"
                                                                        :items="itemautos"
                                                                        item-text="denomination"
                                                                        @change="onChangePrice()"
                                                                        :search-input.sync="searchauto"
                                                                        cache-items
                                                                        flat
                                                                        hide-no-data
                                                                        hide-details
                                                                        clearable
                                                                        return-object
                                                                        label="Choisissez le produit"

                                                                >


                                                                </v-autocomplete>


                                                                <v-row>
                                                                    <v-col cols="12" sm="6" md="6">
                                                                        <v-text-field
                                                                                :rules="prixRules"
                                                                                clearable
                                                                                v-model="editedItem.prix"
                                                                                label="Prix"
                                                                                placeholder="ex : 1250"></v-text-field>

                                                                    </v-col>
                                                                    <v-col cols="12" sm="6" md="6">
                                                                        <v-text-field
                                                                                :rules="qteRules"
                                                                                clearable
                                                                                v-model="editedItem.qte"
                                                                                label="Quantité"
                                                                                placeholder="ex : 25"></v-text-field>

                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>

                                                        </v-col>

                                                    </v-form>

                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                                                    <v-btn color="blue darken-1" :disabled="!valid" text @click="save">
                                                        Sauvegarder
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                        <v-dialog v-model="dialogUp" max-width="800px">

                                            <v-card style="">
                                                <v-card-title>
                                                    <span class="headline">Changer le prix de {{editedItem.produit.denomination}}</span>
                                                </v-card-title>

                                                <v-card-text>
                                                    <v-form ref="form" v-model="valid" :lazy-validation="lazy">

                                                        <v-text-field v-if="submittingUp" color="primary" loading
                                                                      disabled></v-text-field>
                                                        <v-col cols="12" sm="12" md="12">

                                                            <v-container>
                                                                <v-row>
                                                                    <v-col cols="12" sm="12" md="12">
                                                                        <v-text-field
                                                                                :rules="prixRules"
                                                                                clearable
                                                                                v-model="editedItem.prixUp"
                                                                                label="Prix"
                                                                                placeholder="ex : 1250"></v-text-field>

                                                                    </v-col>

                                                                </v-row>
                                                            </v-container>

                                                        </v-col>

                                                    </v-form>

                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue darken-1" text @click="closeUp">Annuler</v-btn>
                                                    <v-btn color="blue darken-1" :disabled="!valid" text
                                                           @click="saveUp">
                                                        Sauvegarder
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-toolbar>
                                </template>
                                <template v-slot:item.actions="{ item }">

                                    <v-icon small @click="editItem(item)" class="p-2">
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon small @click="deleteItem(item)" class="p-2">
                                        mdi-delete
                                    </v-icon>

                                    <router-link :to="{name:'historique',params: {id:item._id,prod:item.produit._id}}"
                                                 class="p-2">
                                        <v-icon small class="mr-2">
                                            mdi-arrow-top-right-bottom-left-bold
                                        </v-icon>
                                    </router-link>

                                </template>
                                <template v-slot:no-data>
                                    <v-btn color="default" @click="initialize">Actualiser</v-btn>
                                </template>
                            </v-data-table>
                            <div class="text-center">
                                <v-container>
                                    <v-row justify="center">
                                        <v-col cols="8">
                                            <v-container class="max-width">
                                                <v-pagination
                                                        v-model="page"
                                                        class="my-4"
                                                        :length="totalpage"
                                                        circle
                                                        prev-icon="mdi-menu-left"
                                                        next-icon="mdi-menu-right"
                                                        @input="clickCallback"
                                                ></v-pagination>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </div>
                        </v-card>
                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>

            </div> <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

    </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";

    export default {
        name: "PharmaProduit",
        components: {},
        data() {
            return {
                loading: false,
                page: 1,
                itemautos: [],
                searchauto: null,
                submitting: false,
                submittingUp: false,
                valid: true,
                lazy: false,
                errors: undefined,
                search: '',
                dialog: '',
                dialogUp: '',
                user: JSON.parse(localStorage.getItem("user")),
                id: undefined,
                snackbar: false,
                textSnack: '',
                items: [
                    {title: 'Depuis notre catalogue'},
                    {title: 'Ajouter plusieurs produits'},
                    {title: 'Nouveau produit'},
                ],
                headers: [
                    {
                        text: 'Image',
                        align: 'start',
                        sortable: true,
                        value: 'produit.photo',
                    },
                    {text: 'Référence', value: 'produit.reference'},
                    {text: 'Dénomination', value: 'produit.denomination'},
                    {text: 'Catégorie', value: 'produit.categorie_slug.libel'},
                    {text: 'Forme', value: 'produit.fp.nom'},
                    {text: 'Prix', value: 'prix'},
                    {text: 'Quantité', value: 'qte'},
                    {text: 'Actions', value: 'actions', sortable: false},

                ],
                editedIndex: -1,
                editedItem: {
                    user_slug: 0,
                    prix: '',
                    qte: 0,
                    produit: '',
                    pharmacie: 0,
                    prixUp: 0,
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    user_slug: 0,
                    prix: '',
                    qte: 0,
                    produit: '',
                    pharmacie: 0,
                    prixUp: 0,
                    _id: 0,
                    created_at: 0,
                },
                produitRules: [
                    v => !!v || 'Produit requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                prixRules: [
                    v => !!v || 'Prix requis',
                ]
                ,
                qteRules: [
                    v => !!v || 'Quantité requis',
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouveau produit" : "Mise à jour"
            }
            ,
            ...mapState('pharmaproduits/', ['pharmaproduits', 'pharmaproduitloading', 'overlay']),
            ...mapState('pharmaproduits/', ['totalpage']),
            ...mapState('produits/', ['produits', 'overlay'])

        }
        ,
        mounted() {
        window.scrollTo(0,0);
            let data2 = new FormData();
            data2.append("id", this.user.relation._id);
            data2.append("page", this.page);
            this.$store.dispatch('pharmaproduits/getPharmaProduits', data2).then(response => {
                window.console.log('pharmaproduits', response)
            });

            console.log("user " + JSON.stringify(this.user));

            let data = new FormData();
            data.append("id", this.user.relation._id);
            this.$store.dispatch('produits/getPharmaNotProduct', data).then(response => {
                window.console.log('produits', response)
            });

        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
            dialogUp(val) {
                val || this.close()
            },
            searchauto(val) {
                val && val != this.editedItem.produit && this.querySelections(val)
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,
            searchCustom() {
                console.log('search');
                console.log(this.search);
                if (this.search.length > 0) {
                    let data3 = new FormData();
                    data3.append("pharmacie", this.user.relation._id);
                    data3.append("str", this.search);
                    this.$store.dispatch('pharmaproduits/getSearch', data3).then(response => {
                        window.console.log('produits', response)
                    });
                } else {
                    let data2 = new FormData();
                    data2.append("id", this.user.relation._id);
                    data2.append("page", 1);
                    this.$store.dispatch('pharmaproduits/getPharmaProduits', data2).then(response => {
                        window.console.log('pharmaproduits', response)
                    });
                }

            },
            clickCallback(pageNum) {
                let data2 = new FormData();
                data2.append("id", this.user.relation._id);
                data2.append("page", pageNum);
                this.$store.dispatch('pharmaproduits/getPharmaProduits', data2).then(response => {
                    window.console.log('pharmaproduits', response)
                });
            },
            querySelections(v) {
                this.loading = true
                // Simulated ajax query
                setTimeout(() => {
                    this.itemautos = this.produits.filter(e => {
                        return (e.denomination || '').toLowerCase().includes((v || '').toLowerCase())
                    });
                    this.loading = false
                }, 500);

                // console.log(v);
                console.log("filtred produits ", this.itemautos);

            },
            editItem(item) {
                this.editedIndex = this.pharmaproduits.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.editedItem.prixUp = this.editedItem.prix;
                this.dialogUp = true;
            },
            onChangePrice() {
                console.log("prod");
                console.log(this.editedItem.produit);
                this.editedItem.prix = this.editedItem.produit.default_price;
            },
            add_produit(index) {


                switch (index) {
                    case 0:
                        this.dialog = true;
                        break;

                    case 1:
                        this.$router.push("attribution");
                        break;

                    case 2:
                        this.$router.push("newproduit");
                        break;
                }

            }
            ,
            deleteItem(item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir supprimé ce élement?",
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('pharmaproduits/deletePharmaProduit', [item._id, this.user.relation._id]).then((result) => {
                            /* console.log("del");
                             console.log(result);*/
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: result.data.message,
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            closeUp() {
                this.dialogUp = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {
                this.submitting = true;
                let data = new FormData();
                data.append("user_slug", this.user._id);
                data.append("pharmacie", this.user.relation._id);
                data.append("prix", this.editedItem.prix);
                data.append("qte", this.editedItem.qte);
                data.append("produit", this.editedItem.produit._id);
                /*  console.log("ELE");
                  console.log(this.editedItem.produit._id);*/
                let mineroute = 'pharmaproduits/setPharmaProduit';
                if (this.editedIndex > -1) {
                    data.append("id", this.editedItem._id);
                    mineroute = 'pharmaproduits/setUpdatePharmaProduit';
                }

                this.$store.dispatch(mineroute, data).then((response) => {
                    // console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.close();
                        this.$store.dispatch('pharmaproduits/getPharmaProduits', this.user.relation).then(response => {
                            window.console.log('pharmaproduits', response)
                        });

                        console.log("user " + JSON.stringify(this.user));

                        let data = new FormData();
                        data.append("id", this.user.relation._id);
                        this.$store.dispatch('produits/getPharmaNotProduct', data).then(response => {
                            window.console.log('produits', response)
                        });
                    }
                })
            },
            saveUp() {
                this.submittingUp = true;
                let data = new FormData();
                data.append("prix", this.editedItem.prixUp);
                data.append("id", this.editedItem._id);
                data.append("pharmacie", this.user.relation._id);

                /*  console.log("ELE");
                  console.log(this.editedItem);*/
                let mineroute = 'pharmaproduits/setPharmaProduit';
                if (this.editedIndex > -1) {
                    data.append("id", this.editedItem._id);
                    mineroute = 'pharmaproduits/setUpdatePharmaProduit';
                }

                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submittingUp = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.closeUp();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor() {
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>